export default __webpack_public_path__ + "assets/images/963e33ede30130a501a07a3fccee6d80.png";